export const COUNTDOWN_TIMER_YEAR = 2020
export const COUNTDOWN_TIMER_MONTH = 10
export const COUNTDOWN_TIMER_DAY = 10
export const COUNTDOWN_TIMER_HOUR = 0
export const COUNTDOWN_TIMER_MINUTE = 0
export const COUNTDOWN_TIMER_SECOND = 0